
import axios from 'axios';
import React, { useContext, useReducer, useState } from 'react';
import { Alert, FormControl, Button, Modal, FormLabel } from 'react-bootstrap';
import { PASSWORD, USERNAME } from '../actions/login.action';
import { BudgetContext } from '../context';
import { EXCEL_URL, LOGIN_PAYLOAD } from '../helpers/constants';
import { GREEN, RED, RED_TEXT } from '../helpers/constants/colors';
import { DUMMY } from '../helpers/functions';
import loginReducer from '../reducers/login.reducer';
import Emoji from './Emoji';
import RenderIf from './RenderIf';

const SaveData = ({
    showWindow = false,
    setIncomes = DUMMY("set income"),
    setExpenses = DUMMY("set expense"),
    closeWindow = DUMMY("close window")
}) => {

    const {incomes, expenses} = useContext(BudgetContext)

    const [loginHeaders, dispatch] = useReducer(loginReducer, LOGIN_PAYLOAD)
    const [err, setErr] = useState("")
    const [mssg, setMssg] = useState("")
    
    const handleLoad = (e) => {
        e.preventDefault()
        axios.get(`${EXCEL_URL}/loadUser`, { headers: loginHeaders })
            .then(({ data }) => {
                setIncomes(data.income)
                setExpenses(data.expense)
                handleClose(e)
            })
            .catch(error => setErr(error.response.data.err))
    }

    const handleSave = (e) => {
        e.preventDefault()
        axios.post(`${EXCEL_URL}/saveUser`,
            {
                income: incomes,
                expense: expenses
            },
            { headers: loginHeaders })
            .then(({ data }) => {
                setErr("")
                setMssg(data.success || data.updated)
            })
            .catch(error => setErr(error.response.data.err))
    }
    const handleClose = (e) => {
        e.preventDefault()
        closeWindow()
        setMssg("")
        setErr("")
        dispatch(USERNAME(""))
        dispatch(PASSWORD(""))
    }
    return (
        <Modal show={showWindow}>
            <RenderIf condition={err || mssg}>
                <div align="center">
                    <Alert variant={err ? RED : GREEN}>{err || mssg}</Alert>
                </div>
            </RenderIf>
            <Modal.Header >
                <Modal.Title>Load/Save Budget</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className={RED_TEXT}>USERNAME AND PASSWORD ARE CASE SENSITIVE!</p>
                <FormLabel>Username</FormLabel>
                <FormControl
                    placeholder="Cannot be traced to you"
                    onChange={(e) => dispatch(USERNAME(e.target.value))} />
                <FormLabel>Password</FormLabel>
                <FormControl
                    placeholder="Should be at least 8 characters"
                    type="password"
                    onChange={(e) => dispatch(PASSWORD(e.target.value))} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant={RED} onClick={handleClose}>Close</Button>
                <Button onClick={handleLoad}>Load Budget <Emoji symbol='🔻'/></Button>
                <Button variant={GREEN} onClick={handleSave}>Save Budget <Emoji symbol='💾' /></Button>
            </Modal.Footer>
        </Modal>
    )
}

export default SaveData;
